module.exports = __webpack_public_path__ + "static/img/webdesign-02.089f7210.png";